import Model from './Model'
import PaymentTransaction from './PaymentTransaction'
export default class Payment extends Model {

    resource()
    {
        return 'payments'
    }

    transactions() {
        return this.hasMany(PaymentTransaction)
    }

    get types () {
        return [{
            handle: 'cash',
            name: 'Cash / Numerar',
        }, {
            handle: 'card',
            name: 'Card Bancar (POS)',
        }, {
            handle: 'wire',
            name: 'Transfer bancar',
        }, {
            handle: 'output',
            name: 'Iesire de numerar'
        }]
    }
}
